import { FormikProvider, useFormikContext } from "formik";
import ComboBox from "../../../../../../../common/components/form/ComboBox";
import { maskLicensePlate } from "../../../../../../../common/helpers/mask.helpers";
import InputMoney from "../../../../../../../common/components/form/CurrencyInputFormik";
import ComboBoxFormik from "../../../../../../../common/components/form/ComboBoxFormik";
import InputFormik from "../../../../../../../common/components/form/InputFormik";
import TextAreaFormik from "../../../../../../../common/components/form/TextAreaFormik";
import { InstallmentOption } from "../../../../../helpers/calculationUtils";

// Definição do tipo do formulário
interface TrafficFineFormValues {
  value: number;
  entryValue: number | string;
  remainingValue: number | string;
  installmentValue: string;
  licensePlate: string;
  description: string;
  renterId: string;
  installmentOption: string;
  nextDueDate: string;
  paymentsIds: string[];
  amoutTrafficNumbers: string;
  actionSelection: string;
}

type NegotiationFineFormProps = {
  groupedFines: { licensePlate: string; totalFine: number; autoNumbers: string[]; paymentIds: string[] }[];
  installmentOptions: InstallmentOption[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleInstallmentOptionChange: (option: any) => void;
  handleSelectedPlate: (plate: string) => void; // nova propriedade
};

export function NegotiationFineForm({ groupedFines, installmentOptions, handleInstallmentOptionChange, handleSelectedPlate }: NegotiationFineFormProps) {
  const formik = useFormikContext<TrafficFineFormValues>();

  return (
    // Apenas uma tag <form> no componente pai (ModalFine)
    <FormikProvider value={formik}>
      <div className="grid grid-cols-2 gap-2">
        <ComboBox
          name='licensePlate'
          label="Escolha a placa do veículo:"
          options={[
            { label: "-", value: "-" },
            ...groupedFines.map(({ licensePlate }) => ({ label: licensePlate, value: licensePlate }))
          ]}
          required={true}
          onChange={handleSelectedPlate}
          mask={maskLicensePlate}
        />

        <InputMoney
          label="Valor total das multas"
          name="value"
          required={true}
          readonly={true}
        />
      </div>

      <div className="grid grid-cols-2 gap-2 mt-4">
        <InputMoney
          label="Valor de entrada"
          name="entryValue"
          required={false}
        />

        <InputMoney
          label="Valor restante para parcelar"
          name="remainingValue"
          required={true}
          readonly={true}
        />
      </div>

      <ComboBoxFormik
        name="installmentOption"
        label="Escolha a opção de parcelamento:"
        options={installmentOptions}
        required={true}
        onChange={handleInstallmentOptionChange}
      />

      <InputFormik
        className="mt-4"
        label="Data de cobrança da primeira parcela - Assinatura"
        name="nextDueDate"
        type="date"
        required={true}
      />

      <InputFormik
        className="mt-4"
        label="Número do auto de infração"
        name="amoutTrafficNumbers"
        required={true}
      />

      <TextAreaFormik
        className='mt-4 flex-1'
        placeholder="Descrição"
        name="description"
        label='Descrição da multa de trânsito'
        onChange={formik.handleChange}
        value={formik.values.description}
        readonly={true}
      />
    </FormikProvider>
  );
}